export const fetchBV = transformedSku => {
    const { $BV } = window;
    if (transformedSku && $BV) {
        try {
            $BV.ui('rr', 'show_reviews', { productId: transformedSku });
            $BV.ui('qa', 'show_questions', { productId: transformedSku });
        } catch (e) {}
    }
};
